import { gql } from '@apollo/client';

export const CREATE_CALMET_WITH_PROCESS_DATA_CONFIGURATION = gql`
    mutation createCalmetWithProcessDataConfiguration($input: CreateCalmetWithProcessDataInput!) {
        facility {
            modelConfigurations {
                calmetConfigurations {
                    createCalmetWithProcessData(input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
